import type { LineString } from 'geojson';
import React from 'react';
import { Layer, Source } from 'react-map-gl';

import { EMap } from '@enums/map.enum';
import { EColors } from '@enums/style.enum';
import { getColor } from '@utils/getColor';

type Props = {
	route: LineString;
};

const MapRoute: React.FC<Props> = ({ route }) => {
	const routeLayerLayout: {
		[EMap.lineJoin]?: EMap.round | EMap.bevel | EMap.miter | EMap.none;
		[EMap.lineCap]?: EMap.round | EMap.butt | EMap.square;
	} = {
		[EMap.lineJoin]: EMap.round,
		[EMap.lineCap]: EMap.round,
	};

	const routeLayerPaint = {
		[EMap.lineColor]: getColor(EColors.mapRoute),
		[EMap.lineWidth]: 4,
		[EMap.lineOpacity]: 1,
	};

	return (
		<Source id={EMap.routeData} type={EMap.geojson} data={route}>
			<Layer id={EMap.routeLayer} type={EMap.line} layout={routeLayerLayout} paint={routeLayerPaint} />
		</Source>
	);
};

export default MapRoute;
